import React from "react";
import StubCover from "../assets/images/stub_cover.webp";

export const CoverImage = ({ cover_file_name, className, alt, width, height }) => {
    return (
        cover_file_name === null
            ? <img className={className} src={StubCover} width={width} height={height} alt={alt} />
            : <img className={className} src={`https://covers.getsimilarbooks.com/covers/${cover_file_name}`} width={width} height={height} alt={alt} />
    )
}